import Features from './FeaturesContainer';

export default Features;
